// @ts-nocheck
import React from "react";
import { BsFacebook } from "react-icons/bs";
import { AiFillTwitterCircle } from "react-icons/ai";
import { FaInstagramSquare } from "react-icons/fa";
import { AiFillLinkedin } from "react-icons/ai";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <section className="bg-themeSecondary sm:py-12 py-8">
      <section
        className="sm:w-11/12 w-10/12 mx-auto grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 
            sm:place-items-center items-start sm:gap-y-10 gap-y-12"
      >
        <div className="sm:space-y-10 space-y-5">
          <div>
            <img src="images/logo2.webp" alt="logo" className="w-48" />
          </div>
          <div className="flex items-center gap-x-3">
            <Link to="https://web.facebook.com/Pacifricaxp" target="_blank">
              <BsFacebook
                className="text-blue-600 cursor-pointer hover:text-themeBlue"
                size={40}
              />
            </Link>
            <Link to="https://twitter.com/pacifricaxp" target="_blank">
              <AiFillTwitterCircle
                className="text-[#1DA1F2] cursor-pointer hover:text-themeBlue"
                size={46}
              />
            </Link>
            <Link
              to="https://www.linkedin.com/company/pacifrica-express"
              target="_blank"
            >
              <AiFillLinkedin
                className="text-[#0A66C2] cursor-pointer hover:text-themeBlue"
                size={46}
              />
            </Link>
            <Link to="https://www.instagram.com/pacifricaxp" target="_blank">
              <FaInstagramSquare
                className="text-[#d1376b] cursor-pointer hover:text-themeBlue"
                size={40}
              />
            </Link>
          </div>
        </div>
        {/* <div className="sm:space-y-8 space-y-5">
          <h3 className="font-bold text-2xl text-themeBlue">How its work</h3>
          <ul className="space-y-4 font-normal text-base text-themeBlue">
            <li>Proccess</li>
            <li>Steps</li>
            <li>Follow instructions</li>
            <li>Accurate Information</li>
          </ul>
        </div> */}
        {/* <div className="sm:space-y-8 space-y-5">
          <h3 className="font-bold text-2xl text-themeBlue">Get a qoute</h3>
          <ul className="space-y-4 font-normal text-base text-themeBlue">
            <li>Amet minim</li>
            <li>Amet minim</li>
            <li>Amet minim</li>
            <li>Amet minim</li>
          </ul>
        </div> */}
        <div className="sm:space-y-8 space-y-5">
          <h3 className="font-bold text-2xl text-themeBlue">Contact us</h3>
          <ul className="space-y-4 font-normal text-base text-themeBlue">
            <li>+27 73 686 8765</li>
            <li>ship@pacifricaxp.com</li>
            <li>
              95 Pony St, Hazeldean, <br />
              Pretoria Gauteng 0084
            </li>
          </ul>
        </div>
        <div className="sm:space-y-8 space-y-5">
          <h3 className="font-bold text-2xl text-themeBlue">About</h3>
          <ul className="space-y-4 font-normal text-base text-themeBlue">
            <li>
              <Link to="/support">Help & Support</Link>
            </li>
            <li>
              <Link to="/terms_and_conditions">Terms & Conditions</Link>
            </li>
            <li>
              <Link to="/privacy_and_policy">Privacy Policy</Link>{" "}
            </li>
          </ul>
        </div>
      </section>
    </section>
  );
}
